<template>
  <v-snackbar
    v-model="showAlert"
    :top="top"
    timeout="-1"
    class="white--text res-alert"
    color="resGreen"
  >
    <v-icon>mdi-check-circle</v-icon>
    <span class="res-alert-text">
      {{ text }}
    </span>

    <template v-slot:action="{}">
      <v-btn icon @click.native="clearText()">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    timeoutInterval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      showAlert: false,
      timeoutId: null,
      top: true,
    };
  },
  methods: {
    clearText() {
      this.text = "";
    },
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  watch: {
    text: function () {
      if (this.text.length > 0) {
        this.showAlert = true;
        this.timeoutId = setTimeout(() => {
          this.text = "";
          this.timeoutId = null;
        }, this.timeoutInterval);
      } else {
        this.showAlert = false;
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.res-alert::v-deep .v-snack__content {
  .v-icon {
    width: 36px;
  }

  span {
    font-size: 16px;
    font-family: roboto;
    letter-spacing: 0em;
    padding-left: 16px;
  }
}
</style>
